import React, { useState } from 'react';
import DrawingModsTab from './DrawingModsTab';

const DRAWING_SUB_TABS = [
  { id: 'mods', label: 'Mods' },
  { id: 'draw', label: 'Draw' },
  { id: 'modify', label: 'Modify' },
  { id: 'text', label: 'Text' },
];

export default function DrawingTab() {
  const [activeSubTab, setActiveSubTab] = useState('mods');

  return (
    <>
      <div className="tab-bar sub-tab-bar">
        {DRAWING_SUB_TABS.map(tab => (
          <button
            key={tab.id}
            className={`tab-bar-item sub-tab-item ${activeSubTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveSubTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tab-content">
        {activeSubTab === 'mods' && <DrawingModsTab />}
        {activeSubTab === 'draw' && <div style={{ padding: 16, color: '#aaa' }}>Yakinda...</div>}
        {activeSubTab === 'modify' && <div style={{ padding: 16, color: '#aaa' }}>Yakinda...</div>}
        {activeSubTab === 'text' && <div style={{ padding: 16, color: '#aaa' }}>Yakinda...</div>}
      </div>
    </>
  );
}
